import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@brunata-angular/util';

@Pipe({
    name: 'eventAlarm',
    standalone: true,
})
export class EventAlarmPipe implements PipeTransform {
    private translateService = inject(TranslateService);
    transform(value: string): string {
        switch (value) {
            case '5': {
                return this.translateService.translate('event-alarms_Hardware');
            }
            case '6': {
                return this.translateService.translate('event-alarms_Leakage');
            }
            case '7': {
                return this.translateService.translate('event-alarms_TamperedInPast');
            }
            case '21': {
                return this.translateService.translate('event-alarms_ReverseFlow');
            }
            case '22': {
                return this.translateService.translate('event-alarms_Dry');
            }
            case '23': {
                return this.translateService.translate('event-alarms_Burst');
            }
            case '62': {
                return this.translateService.translate('event-alarms_BatteryEOL');
            }
            case '63': {
                return this.translateService.translate('event-alarms_ContinuousFlow');
            }
            case '64': {
                return this.translateService.translate('event-alarms_Dismounted');
            }
            case '183': {
                return this.translateService.translate('event-alarms_LowTemperature');
            }
            default: {
                return value;
            }
        }
    }
}
